module.exports = __webpack_public_path__ + "static/media/Pista_Unha.ba6fdd7c.png";